import type { ReactNode } from 'react';

export const symbol_closed_caption: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h600q24 0 42 18t18 42v520q0 24-18 42t-42 18H180Zm0-60h600v-520H180v520Zm90-141h142q12.75 0 21.38-8.63Q442-378.25 442-391v-20q0-9.86-6.57-16.43T419-434h-4q-9.86 0-16.43 6.57T392-411H290v-138h102q0 10 6.57 16.5T415-526h4q9.86 0 16.43-6.57T442-549v-20q0-12.75-8.62-21.38Q424.75-599 412-599H270q-12.75 0-21.37 8.62Q240-581.75 240-569v178q0 12.75 8.63 21.37Q257.25-361 270-361Zm421-238H549q-12.75 0-21.37 8.62Q519-581.75 519-569v178q0 12.75 8.63 21.37Q536.25-361 549-361h142q12.75 0 21.38-8.63Q721-378.25 721-391v-20q0-9.86-6.57-16.43T698-434h-4q-9.86 0-16.43 6.57T671-411H569v-138h102q0 10 6.57 16.5T694-526h4q9.86 0 16.43-6.57T721-549v-20q0-12.75-8.62-21.38Q703.75-599 691-599ZM180-220v-520 520Z"
		/>
	</svg>
);
